import { cachedUserSeesHome } from "@/lib/navigation";
import DashboardPage from "@/pages/dashboard";
import { DataService } from "@/services/data";
import { RouteObject } from "react-router-dom";
import { PaginatedResponse } from "@/types/common";
import { TaskType } from "@/types/user";
import { DateTime } from "luxon";
import { handle_error } from "@/utils/wretch";
import { toast } from "sonner";

const DashboardRoute: RouteObject = {
    path: "/",
    element: <DashboardPage />,
    loader: async ({ request }) => {
        // A user who may not use the dashboard is sent to their first menu entry by the layout.
        // The cached user can be missing or stale (fresh login, view-as), hence the 403 fallback.
        if (!cachedUserSeesHome()) return { tasks: [] };
        const url = new URL(request.url);
        url.searchParams.set("page_size", "1000");
        const search_param = url.searchParams.get("search");

        if (search_param) {
            url.searchParams.set("smart_search", search_param);
            url.searchParams.delete("search");
        }

        if (!url.searchParams.has("due_date__range") && !url.searchParams.has("overdue") && !search_param) {
            const today = DateTime.now().toFormat("yyyy-MM-dd");
            url.searchParams.set("due_date__range", `${today},${today}`);
        }

        if (!url.searchParams.has("o")) {
            url.searchParams.set("o", "priority");
        }

        const tasks = (await DataService.client
            .url(`/users/tasks/${url.searchParams ? "?" + url.searchParams.toString() : ""}`)
            .get()
            .forbidden(() => null)
            .json()) as PaginatedResponse<TaskType> | null;

        return {
            tasks: tasks?.results ?? []
        };
    },
    action: async ({ request }) => {
        const data = await request.json();
        try {
            await DataService.client.url(`/users/tasks/`).post(data).json();
            toast.success("Tâche créée");
            return null;
        } catch (error) {
            return handle_error(error);
        }
    },
    children: [
        {
            path: ":taskId",
            action: async ({ params, request }) => {
                const taskId = params.taskId;
                const data = await request.json();
                try {
                    let content;
                    if (request.method == "POST") {
                        content = await DataService.client.url(`/users/tasks/${taskId}/`).patch(data).json();
                        toast.success("Tâche mise-à-jour");
                    } else if (request.method == "DELETE") {
                        content = await DataService.client.url(`/users/tasks/${taskId}/`).delete().json();
                        toast.success("Tâche supprimée");
                    }
                    return { success: true, content: content };
                } catch (error) {
                    return handle_error(error);
                }
            }
        }
    ]
};

export default DashboardRoute;
